import { useMemo, useRef } from 'react';

import { PresentationSlideWrapper } from '@/modules/presentation/clientPresentation/PresentationSlideWrapper';
import { PresentationSlide } from '@/modules/presentation/PresentationSlide';
import { CoverSlide } from '@/modules/slideEditor/coverSlide/CoverSlide';
import { SlideHoverHaloRefs } from '@/modules/slideEditor/coverSlide/CoverSlide.types';
import { BrandedPreviewSlide } from '@/modules/slideEditor/shared/BrandedPreviewSlide';
import { SlideEditorCoverPage } from '@/modules/slideEditor/SlideEditor.types';

import {
  formToSlideDesign,
  SLIDE_PREVIEW_BODY_TEXT,
} from './SlideConfigForm.constants';
import { SlideConfigFormShape } from './SlideConfigForm.types';
import { SlideOriginDragOverlay } from './SlideOriginDragOverlay';

const PREVIEW_COVER_PAGE: SlideEditorCoverPage['page'] = {
  customContent: SLIDE_PREVIEW_BODY_TEXT,
  displayTitle: 'Estate Planning Review',
  customPrompt: null,
};

export function CoverSlideConfigPreview(formValues: SlideConfigFormShape) {
  const tenantSlideDesign = formToSlideDesign(formValues);
  const slideRef = useRef<HTMLDivElement | null>(null);

  // Refs to slide-internal hover targets. The slide attaches them; the
  // drag overlay reads them on hover to outline the matching element.
  const titleHaloTargetRef = useRef<HTMLDivElement | null>(null);
  const customLogoRef = useRef<HTMLDivElement | null>(null);
  const hoverHaloRefs = useMemo<SlideHoverHaloRefs>(
    () => ({
      titleHaloTarget: titleHaloTargetRef,
      customLogo: customLogoRef,
    }),
    []
  );

  return (
    // Override the wrapper's default pointerEvents:none so the drag
    // overlay (mounted inside the slide via the slideOverlay slot) can
    // receive events. The overlay sits above the slide's text editors
    // and absorbs idle clicks, keeping the preview non-editable.
    <PresentationSlideWrapper ref={slideRef} sx={{ pointerEvents: 'auto' }}>
      <CoverSlide
        Slide={BrandedPreviewSlide}
        page={PREVIEW_COVER_PAGE}
        bundle={null}
        slideId="cover-slide-config-preview"
        tenantSlideDesign={tenantSlideDesign}
        footer={<PresentationSlide.Footer />}
        hoverHaloRefs={hoverHaloRefs}
        slideOverlay={
          <SlideOriginDragOverlay
            slideRef={slideRef}
            hoverHaloRefs={hoverHaloRefs}
          />
        }
      />
    </PresentationSlideWrapper>
  );
}
